import { UserParticipationStatus, Visibility } from '@core-http';
import { GameDetailsModel } from '../interfaces';

export const isPrivateGame = (game: GameDetailsModel): boolean => {
  if (game.visibility !== Visibility.PRIVATE) return false;

  const status: UserParticipationStatus | undefined = game.gameParticipationStatus;
  return !status || status === UserParticipationStatus.Empty;
};
